var $431075d23cacb554$exports = {};
$431075d23cacb554$exports = {
    "alert": `Upozorenje`,
    "dismiss": `Odbaci`
};


export {$431075d23cacb554$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
